
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _404g_45D5gIvaF5fPJlDu97Kw1AFsnJ4_459Kx1vFN_45_sj7wfoMeta } from "/opt/buildhome/repo/pages/404.vue?macro=true";
import { default as appt714oqXFI3THznJHimC3CmJNVFOGgDUfURgwFH6meeEMeta } from "/opt/buildhome/repo/pages/app.vue?macro=true";
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as planstWGR4_45aRqZB_45R_NtlriSQsGVcw4UdyOHDcvN9a764_IMeta } from "/opt/buildhome/repo/pages/plans.vue?macro=true";
import { default as careersrtrgUQj52TdbMt0kFBEVGh7IuHaMPsxHAEBw6tGV_45OUMeta } from "/opt/buildhome/repo/pages/careers.vue?macro=true";
import { default as contactxgbCBTXU_45d0XJYTpbmfD1UGZKjSEtzA80xt962KkT7QMeta } from "/opt/buildhome/repo/pages/contact.vue?macro=true";
import { default as sitemapRAisXoZK5HnX9gP4GeOCNyiX2jhMw_43c23RS0_z7RoMeta } from "/opt/buildhome/repo/pages/sitemap.vue?macro=true";
import { default as workingGCcnAsMUs4AvZLi7XXBI4Nrfj8537KA6yrhFAc5Kv7gMeta } from "/opt/buildhome/repo/pages/working.vue?macro=true";
import { default as indexBeHzAQikKrSJqk6imgHKGnYps5J2m1dpAlMAyv_MDnQMeta } from "/opt/buildhome/repo/pages/blog/index.vue?macro=true";
import { default as modal_45testaxXdgf710fBWpuwuo_I_45k8_iNuD5aw_453jWmdQRws1x4Meta } from "/opt/buildhome/repo/pages/modal-test.vue?macro=true";
import { default as index0v_4599X6BjoN7rkqBDw0pjTpHUEvxQysgZr2clb9r59MMeta } from "/opt/buildhome/repo/pages/news/index.vue?macro=true";
import { default as ccpa_45policyOjHgLfM67pq2PjiBtWlzgrS2Pcl6lDLqstZWHDpltx4Meta } from "/opt/buildhome/repo/pages/ccpa-policy.vue?macro=true";
import { default as index18Q0NxznJUDNyQYVJfY4upidYG_4Bfu6NM5u966ahJMMeta } from "/opt/buildhome/repo/pages/scans/index.vue?macro=true";
import { default as member_45termsrmygMXdPzcn4DufEBRh3q0JWK60zROXaEPIWJADDJjQMeta } from "/opt/buildhome/repo/pages/member-terms.vue?macro=true";
import { default as indexjYLHr6NXjpvFf_gXujeNDoOTZnxcSaS9oAuKnKWOqgoMeta } from "/opt/buildhome/repo/pages/search/index.vue?macro=true";
import { default as trading_45hw_451DiWoB5FDym9lfsVk8viuZqhB5UJxvNRJy0xEmS4sgGAMeta } from "/opt/buildhome/repo/pages/trading-hw-1.vue?macro=true";
import { default as trading_45hw_452Pb0nmvRL4SiyKY4e3yXK0nnZCJOQCGpW03tjAvnHVw4Meta } from "/opt/buildhome/repo/pages/trading-hw-2.vue?macro=true";
import { default as trading_45hw_453MLEXbQVJl4qt4Fq3E_45mVe6v6jGkjTHhN6R7DyxQIPEYMeta } from "/opt/buildhome/repo/pages/trading-hw-3.vue?macro=true";
import { default as trading_45hw_454z8QphDm0nC862noWPnBdkWcV2vYYuvfSt9GYmiFd8vkMeta } from "/opt/buildhome/repo/pages/trading-hw-4.vue?macro=true";
import { default as trading_45hw_455KJDg0M8fPD8jNg5rmleVff22JKqacu7R5lVOkiaRVJwMeta } from "/opt/buildhome/repo/pages/trading-hw-5.vue?macro=true";
import { default as aizen_45previewmBJAAGe5iR8qULWDtNPCNK_FuwNXPslbobzC7fko_UIMeta } from "/opt/buildhome/repo/pages/aizen-preview.vue?macro=true";
import { default as cookie_45policyMIFETaySFO4h2vvjlHBOZNyTe_k1Vy9bHWMdPvEBTrUMeta } from "/opt/buildhome/repo/pages/cookie-policy.vue?macro=true";
import { default as indexAKXrc4HHm241ni_45Jok_45u8ZIYlT6AR1EJTWKbwECq0jMMeta } from "/opt/buildhome/repo/pages/reviews/index.vue?macro=true";
import { default as _91_46_46_46slug_93ZySbWuWn1jSYDKSNhP4MFqlpeqXxSz1jYpkAc9yGIasMeta } from "/opt/buildhome/repo/pages/tag/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_939rdh_45n_45HjMQ0pGK9_XMEzHxE7imbYnKWrXA3lXKxBtgMeta } from "/opt/buildhome/repo/pages/blog/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93Jxb8LGrit9ZcPIemFD2h_Jzf0St1HDk9Mscvz26OvnkMeta } from "/opt/buildhome/repo/pages/news/[...slug].vue?macro=true";
import { default as privacy_45policyek63hKQ8ZMx2nIQV88L2_dad1Zv4m5Ym_n4RQ7NuSXAMeta } from "/opt/buildhome/repo/pages/privacy-policy.vue?macro=true";
import { default as code_45of_45conductPpUQj6_45jUmcqdN4rLU8CaSanPPWYiD2EgFuDsJTrvc4Meta } from "/opt/buildhome/repo/pages/code-of-conduct.vue?macro=true";
import { default as _91_46_46_46widget_45page_934VmtVJIr_Robgq7c0yV_45tXyywW7MCCNUH6AmMQLmRCIMeta } from "/opt/buildhome/repo/pages/[...widget-page].vue?macro=true";
import { default as _91_46_46_46stock_939HoR_ezC9KqOg1iHmPPUWnHL6i8mwnMcHa7lApuHu_kMeta } from "/opt/buildhome/repo/pages/quote/[...stock].vue?macro=true";
import { default as terms_45of_45serviceW1t_45jMqJI4Xxtn_45N8YS_45DQhUyytODfRcGH7elbilobAMeta } from "/opt/buildhome/repo/pages/terms-of-service.vue?macro=true";
import { default as trading_45hw_45bonus5aaGnDZlVU_KdRgnkXAXg6VFAmpf__QrcD3lK0fNPEUMeta } from "/opt/buildhome/repo/pages/trading-hw-bonus.vue?macro=true";
import { default as stock_45loserskz5RGGE_45QR_MZgEmC91dhlJhFapsbNroYzP7A_H0eMMMeta } from "/opt/buildhome/repo/pages/scans/stock-losers.vue?macro=true";
import { default as _91_46_46_46page_93ZuQinZkX8c_vej011pDVcVIIiG5V33iFgM2VDl_45vB60Meta } from "/opt/buildhome/repo/pages/blog/page/[...page].vue?macro=true";
import { default as stock_45gainersVT1wyo4vKQmoUW6WXhj8_45x_45GuVhs20KOmy0jIsQ18_45wMeta } from "/opt/buildhome/repo/pages/scans/stock-gainers.vue?macro=true";
import { default as affiliate_45disclosurejoYcFvZleYcgRJzcoUE4_QS9tWRFDz4nqpNruO56C90Meta } from "/opt/buildhome/repo/pages/affiliate-disclosure.vue?macro=true";
import { default as dmca_45takedown_45policyutnibTfs_Gke9mE6lH8NMYHyMh1o8_NgVC8JRrI0ex0Meta } from "/opt/buildhome/repo/pages/dmca-takedown-policy.vue?macro=true";
import { default as editorial_45guidelinesfF_ofOV_tGDJQJc0tiy02m6jSkWt7aT4yWWCwKWJjw0Meta } from "/opt/buildhome/repo/pages/editorial-guidelines.vue?macro=true";
import { default as millionaire_45challengekFX55_45qtQm7lGs1GzIO5cbp4x_kg1UK2zqTJwEDwZegMeta } from "/opt/buildhome/repo/pages/millionaire-challenge.vue?macro=true";
import { default as _91_46_46_46number_931GNrDDuZy80ER_45BTUkCwdjhbRERyTuxYlLInhuD5wesMeta } from "/opt/buildhome/repo/pages/news/page/[...number].vue?macro=true";
import { default as _91_46_46_46slug_93Pc_45UbUTDw_45a5bidqKc9w_45MfWt6q32ZFiSHyWV5TFGqkMeta } from "/opt/buildhome/repo/pages/blog/tim-video/[...slug].vue?macro=true";
import { default as my_45weekend_45planIXC5x9cnX82TGXDVcHcGF_cbVhRbYLaNKiHUGhWf0b8Meta } from "/opt/buildhome/repo/pages/tim-news/my-weekend-plan.vue?macro=true";
import { default as earnings_45claims_45disclosureaS_45R_OFxMxAtcdwKff3J3D1K6hyTEnu5cSg8D64PmYAMeta } from "/opt/buildhome/repo/pages/earnings-claims-disclosure.vue?macro=true";
import { default as _91_46_46_46page_930h1963bG7Zm0OUF8c3di4rJGT5bLzQ_45nkLs_45alZ3Cs0Meta } from "/opt/buildhome/repo/pages/category/[...category-slug]/page/[...page].vue?macro=true";
import { default as _91_46_46_46category_45slug_93eiPrR6fBaQ5hJ3UAxQfhJyobYYOVj4x7jEsq49pGD_wMeta } from "/opt/buildhome/repo/pages/category/[...category-slug].vue?macro=true";
import { default as highest_45volume_45stocks_45jkPN_AEUIXKgrr28z2ctZaPQPPhliOZVkX5lT_JLvgMeta } from "/opt/buildhome/repo/pages/scans/highest-volume-stocks.vue?macro=true";
import { default as unusual_45volume_45stocksmx_sMMX9AT2IzTEwQlJx6WFDpfNyjC_45oRJvxuncuGp8Meta } from "/opt/buildhome/repo/pages/scans/unusual-volume-stocks.vue?macro=true";
import { default as _91_46_46_46author_45name_932r_XdiqaYc1scnICJv9YyqorsymxFUcNvwzy64_ToDkMeta } from "/opt/buildhome/repo/pages/blog/author/[...author-name].vue?macro=true";
import { default as my_45worst_45loss_45of_452022zt5HecyTTlU8YIVmWcDFHM5DXHsb3Hap1Ju0lPrUNz4Meta } from "/opt/buildhome/repo/pages/tim-news/my-worst-loss-of-2022.vue?macro=true";
import { default as artificial_45intelligence_45disclosuretOPZpGDPIauSl21NSXvpZF_ygQ3EB12twiyWsA6p2tgMeta } from "/opt/buildhome/repo/pages/artificial-intelligence-disclosure.vue?macro=true";
import { default as one_45meme_45stock_45perfect_45setup6XF5n2m22vNDJUmMZuPMopn27s2UrsL612pXPtSkOhgMeta } from "/opt/buildhome/repo/pages/tim-news/one-meme-stock-perfect-setup.vue?macro=true";
import { default as what_45meme_45stocks_45im_45watching4yGopRKDh3iIh5eNBTtfSeIBiUFTVDR6nVjP_4FFXesMeta } from "/opt/buildhome/repo/pages/tim-news/what-meme-stocks-im-watching.vue?macro=true";
import { default as heres_45what_45happened_45with_45inndfdCWRWNh_45NWnAKrBbyTeSWyyZ72sSzAAqmVbDogSe5wMeta } from "/opt/buildhome/repo/pages/tim-news/heres-what-happened-with-innd.vue?macro=true";
import { default as my_45plan_45after_45a_45horrible_45tradecZHUovyPwFffayesEVoBKKamkFoWNaou8GbcmyHGW4QMeta } from "/opt/buildhome/repo/pages/tim-news/my-plan-after-a-horrible-trade.vue?macro=true";
import { default as these_454_45stocks_45are_45spiking_45quickOmPD38Ef6x38k8k0zIMFPbu5MnoH5rBcMg0kUo0Mk58Meta } from "/opt/buildhome/repo/pages/tim-news/these-4-stocks-are-spiking-quick.vue?macro=true";
import { default as disclosure_45of_45related_45and_45partner_45entities87hWiV4urb203_Wo7VnZ1DGkHMYhOvImkUSBd9X_45168Meta } from "/opt/buildhome/repo/pages/disclosure-of-related-and-partner-entities.vue?macro=true";
import { default as my_45go_45to_45pattern_45for_45market_45drops8q59U4qOJgi2CJhk9V82L49bsWwnTJiCuQH12zwGYRoMeta } from "/opt/buildhome/repo/pages/tim-news/my-go-to-pattern-for-market-drops.vue?macro=true";
import { default as _3_45stocks_45i_45struck_45gold_45in_45this_45volatile_45market29GK2GEpAB3paeFY0K3JBIeecHkxA18Q0MQyqMbxRrcMeta } from "/opt/buildhome/repo/pages/tim-news/3-stocks-i-struck-gold-in-this-volatile-market.vue?macro=true";
import { default as these_45otc_45plays_45are_45working_45are_45working_45right_45now5GXXpWHgFg7vBmiG_IlscorrA0DHWJfaxXFnwV2gVuUMeta } from "/opt/buildhome/repo/pages/tim-news/these-otc-plays-are-working-are-working-right-now.vue?macro=true";
export default [
  {
    name: "404",
    path: "/404",
    meta: _404g_45D5gIvaF5fPJlDu97Kw1AFsnJ4_459Kx1vFN_45_sj7wfoMeta || {},
    component: () => import("/opt/buildhome/repo/pages/404.vue")
  },
  {
    name: "app",
    path: "/app",
    component: () => import("/opt/buildhome/repo/pages/app.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "plans",
    path: "/plans",
    component: () => import("/opt/buildhome/repo/pages/plans.vue")
  },
  {
    name: "careers",
    path: "/careers",
    component: () => import("/opt/buildhome/repo/pages/careers.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/opt/buildhome/repo/pages/contact.vue")
  },
  {
    name: "sitemap",
    path: "/sitemap",
    component: () => import("/opt/buildhome/repo/pages/sitemap.vue")
  },
  {
    name: "working",
    path: "/working",
    component: () => import("/opt/buildhome/repo/pages/working.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/opt/buildhome/repo/pages/blog/index.vue")
  },
  {
    name: "modal-test",
    path: "/modal-test",
    component: () => import("/opt/buildhome/repo/pages/modal-test.vue")
  },
  {
    name: "news",
    path: "/news",
    component: () => import("/opt/buildhome/repo/pages/news/index.vue")
  },
  {
    name: "ccpa-policy",
    path: "/ccpa-policy",
    component: () => import("/opt/buildhome/repo/pages/ccpa-policy.vue")
  },
  {
    name: "scans",
    path: "/scans",
    component: () => import("/opt/buildhome/repo/pages/scans/index.vue")
  },
  {
    name: "member-terms",
    path: "/member-terms",
    component: () => import("/opt/buildhome/repo/pages/member-terms.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/opt/buildhome/repo/pages/search/index.vue")
  },
  {
    name: "trading-hw-1",
    path: "/trading-hw-1",
    component: () => import("/opt/buildhome/repo/pages/trading-hw-1.vue")
  },
  {
    name: "trading-hw-2",
    path: "/trading-hw-2",
    component: () => import("/opt/buildhome/repo/pages/trading-hw-2.vue")
  },
  {
    name: "trading-hw-3",
    path: "/trading-hw-3",
    component: () => import("/opt/buildhome/repo/pages/trading-hw-3.vue")
  },
  {
    name: "trading-hw-4",
    path: "/trading-hw-4",
    component: () => import("/opt/buildhome/repo/pages/trading-hw-4.vue")
  },
  {
    name: "trading-hw-5",
    path: "/trading-hw-5",
    component: () => import("/opt/buildhome/repo/pages/trading-hw-5.vue")
  },
  {
    name: "aizen-preview",
    path: "/aizen-preview",
    meta: aizen_45previewmBJAAGe5iR8qULWDtNPCNK_FuwNXPslbobzC7fko_UIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/aizen-preview.vue")
  },
  {
    name: "cookie-policy",
    path: "/cookie-policy",
    component: () => import("/opt/buildhome/repo/pages/cookie-policy.vue")
  },
  {
    name: "reviews",
    path: "/reviews",
    component: () => import("/opt/buildhome/repo/pages/reviews/index.vue")
  },
  {
    name: "tag-slug",
    path: "/tag/:slug(.*)*",
    component: () => import("/opt/buildhome/repo/pages/tag/[...slug].vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug(.*)*",
    meta: _91_46_46_46slug_939rdh_45n_45HjMQ0pGK9_XMEzHxE7imbYnKWrXA3lXKxBtgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/blog/[...slug].vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug(.*)*",
    component: () => import("/opt/buildhome/repo/pages/news/[...slug].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/opt/buildhome/repo/pages/privacy-policy.vue")
  },
  {
    name: "code-of-conduct",
    path: "/code-of-conduct",
    component: () => import("/opt/buildhome/repo/pages/code-of-conduct.vue")
  },
  {
    name: "widgetpage",
    path: "/:widgetpage(.*)*",
    meta: _91_46_46_46widget_45page_934VmtVJIr_Robgq7c0yV_45tXyywW7MCCNUH6AmMQLmRCIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/[...widget-page].vue")
  },
  {
    name: "quote-stock",
    path: "/quote/:stock(.*)*",
    component: () => import("/opt/buildhome/repo/pages/quote/[...stock].vue")
  },
  {
    name: "terms-of-service",
    path: "/terms-of-service",
    component: () => import("/opt/buildhome/repo/pages/terms-of-service.vue")
  },
  {
    name: "trading-hw-bonus",
    path: "/trading-hw-bonus",
    component: () => import("/opt/buildhome/repo/pages/trading-hw-bonus.vue")
  },
  {
    name: "scans-stock-losers",
    path: "/scans/stock-losers",
    component: () => import("/opt/buildhome/repo/pages/scans/stock-losers.vue")
  },
  {
    name: "blog-page-page",
    path: "/blog/page/:page(.*)*",
    component: () => import("/opt/buildhome/repo/pages/blog/page/[...page].vue")
  },
  {
    name: "scans-stock-gainers",
    path: "/scans/stock-gainers",
    component: () => import("/opt/buildhome/repo/pages/scans/stock-gainers.vue")
  },
  {
    name: "affiliate-disclosure",
    path: "/affiliate-disclosure",
    component: () => import("/opt/buildhome/repo/pages/affiliate-disclosure.vue")
  },
  {
    name: "dmca-takedown-policy",
    path: "/dmca-takedown-policy",
    component: () => import("/opt/buildhome/repo/pages/dmca-takedown-policy.vue")
  },
  {
    name: "editorial-guidelines",
    path: "/editorial-guidelines",
    component: () => import("/opt/buildhome/repo/pages/editorial-guidelines.vue")
  },
  {
    name: "millionaire-challenge",
    path: "/millionaire-challenge",
    meta: millionaire_45challengekFX55_45qtQm7lGs1GzIO5cbp4x_kg1UK2zqTJwEDwZegMeta || {},
    component: () => import("/opt/buildhome/repo/pages/millionaire-challenge.vue")
  },
  {
    name: "news-page-number",
    path: "/news/page/:number(.*)*",
    component: () => import("/opt/buildhome/repo/pages/news/page/[...number].vue")
  },
  {
    name: "blog-tim-video-slug",
    path: "/blog/tim-video/:slug(.*)*",
    component: () => import("/opt/buildhome/repo/pages/blog/tim-video/[...slug].vue")
  },
  {
    name: "tim-news-my-weekend-plan",
    path: "/tim-news/my-weekend-plan",
    component: () => import("/opt/buildhome/repo/pages/tim-news/my-weekend-plan.vue")
  },
  {
    name: "earnings-claims-disclosure",
    path: "/earnings-claims-disclosure",
    component: () => import("/opt/buildhome/repo/pages/earnings-claims-disclosure.vue")
  },
  {
    name: "category-categoryslug",
    path: "/category/:categoryslug(.*)*",
    component: () => import("/opt/buildhome/repo/pages/category/[...category-slug].vue"),
    children: [
  {
    name: "category-categoryslug-page-page",
    path: "page/:page(.*)*",
    component: () => import("/opt/buildhome/repo/pages/category/[...category-slug]/page/[...page].vue")
  }
]
  },
  {
    name: "scans-highest-volume-stocks",
    path: "/scans/highest-volume-stocks",
    component: () => import("/opt/buildhome/repo/pages/scans/highest-volume-stocks.vue")
  },
  {
    name: "scans-unusual-volume-stocks",
    path: "/scans/unusual-volume-stocks",
    component: () => import("/opt/buildhome/repo/pages/scans/unusual-volume-stocks.vue")
  },
  {
    name: "blog-author-authorname",
    path: "/blog/author/:authorname(.*)*",
    component: () => import("/opt/buildhome/repo/pages/blog/author/[...author-name].vue")
  },
  {
    name: "tim-news-my-worst-loss-of-2022",
    path: "/tim-news/my-worst-loss-of-2022",
    component: () => import("/opt/buildhome/repo/pages/tim-news/my-worst-loss-of-2022.vue")
  },
  {
    name: "artificial-intelligence-disclosure",
    path: "/artificial-intelligence-disclosure",
    component: () => import("/opt/buildhome/repo/pages/artificial-intelligence-disclosure.vue")
  },
  {
    name: "tim-news-one-meme-stock-perfect-setup",
    path: "/tim-news/one-meme-stock-perfect-setup",
    component: () => import("/opt/buildhome/repo/pages/tim-news/one-meme-stock-perfect-setup.vue")
  },
  {
    name: "tim-news-what-meme-stocks-im-watching",
    path: "/tim-news/what-meme-stocks-im-watching",
    component: () => import("/opt/buildhome/repo/pages/tim-news/what-meme-stocks-im-watching.vue")
  },
  {
    name: "tim-news-heres-what-happened-with-innd",
    path: "/tim-news/heres-what-happened-with-innd",
    component: () => import("/opt/buildhome/repo/pages/tim-news/heres-what-happened-with-innd.vue")
  },
  {
    name: "tim-news-my-plan-after-a-horrible-trade",
    path: "/tim-news/my-plan-after-a-horrible-trade",
    component: () => import("/opt/buildhome/repo/pages/tim-news/my-plan-after-a-horrible-trade.vue")
  },
  {
    name: "tim-news-these-4-stocks-are-spiking-quick",
    path: "/tim-news/these-4-stocks-are-spiking-quick",
    component: () => import("/opt/buildhome/repo/pages/tim-news/these-4-stocks-are-spiking-quick.vue")
  },
  {
    name: "disclosure-of-related-and-partner-entities",
    path: "/disclosure-of-related-and-partner-entities",
    component: () => import("/opt/buildhome/repo/pages/disclosure-of-related-and-partner-entities.vue")
  },
  {
    name: "tim-news-my-go-to-pattern-for-market-drops",
    path: "/tim-news/my-go-to-pattern-for-market-drops",
    component: () => import("/opt/buildhome/repo/pages/tim-news/my-go-to-pattern-for-market-drops.vue")
  },
  {
    name: "tim-news-3-stocks-i-struck-gold-in-this-volatile-market",
    path: "/tim-news/3-stocks-i-struck-gold-in-this-volatile-market",
    component: () => import("/opt/buildhome/repo/pages/tim-news/3-stocks-i-struck-gold-in-this-volatile-market.vue")
  },
  {
    name: "tim-news-these-otc-plays-are-working-are-working-right-now",
    path: "/tim-news/these-otc-plays-are-working-are-working-right-now",
    component: () => import("/opt/buildhome/repo/pages/tim-news/these-otc-plays-are-working-are-working-right-now.vue")
  }
]